import React from 'react';
import NavigationItem from './NavigationItem/NavigationItem';

const NavigationItems = (props) => {
	return (
		<>
			<NavigationItem link='https://www.linkedin.com/in/olesia-garbuzova/'>
				LinkedIn
			</NavigationItem>
			<NavigationItem link='https://github.com/olesia-ag'>
				GitHub
			</NavigationItem>
		</>
	);
};


export default NavigationItems;
